import { render, staticRenderFns } from "./DeleteBank.vue?vue&type=template&id=74da104d&"
import script from "./DeleteBank.vue?vue&type=script&lang=js&"
export * from "./DeleteBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports